/**=========================================================
 * Module: search.js
 * Search Controller
 =========================================================*/

 App.controller('SearchController',
 ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter',
 function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter) {
   "use strict";

    var rsel = $rootScope.$on('$closeSearch', function(){
      changeStatus('')
      //$('.search-bar').css('width', '300px');
    });

    let changeStatus = function(newStatus){
      $timeout(function(){
        $('.search-status-' + $scope.searchStatus).css('display','none');
        $('.search-status-' + newStatus).css('display','block');
        $scope.searchStatus = newStatus;
      }, 0)
    }

    $scope.resizeSearch = function(){
      let w = $(window).width()-700; //$('nav').width()-$('.navbar-header').width()-$('.navbar-right').width()-80
      $('.search-bar').width(w > 500 ? 500 : (w < 200 ? 200 : w));
    }

    // Normalize state on resize to avoid multiple checks
    $(window).on('resize', function() {
      $scope.resizeSearch()
    })

    $scope.$on('$destroy', rsel);

    $scope.resetQuery = function(){
      $scope.searchQuery = '';
      changeStatus('')
      
    }

    $scope.focusSearch = function(){
      if($scope.searchQuery && $scope.searchStatus!='started'){
        changeStatus('ended')
      }
      var w = $('nav').width()-$('.navbar-header').width()-$('.navbar-info').width()-$('.tmIcons').width()-$('.navbar-right').width()-50;
      if(w>500) w = 500;
      if(w<300) w = 300;
      //$('.search-bar').css('width', w + 'px');
    }

    $scope.showMore = function(type){
      $scope.limit[type] += 5;
    }
    
    $scope.searchQuery = '';
    changeStatus('');
    $scope.searchResults = {
      project: null,
      projectnotes: null,
      message: null,
      account: null,
      group: null
    };
    $scope.limit = {
      project: 5,
      projectnotes: 4,
      message: 4,
      account: 3,
      group: 2
    }
    
    var searchTimeout = null;
    $scope.doSearch = function(){
      if(searchTimeout){
        $timeout.cancel(searchTimeout);
      }
      searchTimeout = $timeout(search, 500);
      $rootScope.$broadcast('$tooltipClose', { pid: 'general', tid: 'search', fromEvent: true });
    }

    $scope.searchCounter = 0;

    let currentSearchQuery = ''

    

    var search = function(){
        if(!$scope.searchQuery || $scope.searchQuery.trim()=='') return;
        let types = $rootScope.user.admin ? ['Project', 'ProjectNotes', 'Message', 'Account', 'Group'] : ['Project', 'Message'];
        currentSearchQuery = $scope.searchQuery;
      //$timeout(function(){
        changeStatus('started')
        $scope.searchResults = {};
        $scope.searchCounter = 0;
        
        let s = function(sq){
          for(var i=0; i<types.length; i++){
            let TYPE = types[i];
            $scope.searchCounter++;
            D.query('search','query=' + sq + '&type=' + TYPE).then(function(response){
              if(currentSearchQuery!=sq) {
                $scope.searchCounter--
                if($scope.searchCounter==0){
                  changeStatus('ended')
                }
                return;
              }
              for(var i=0; i<response.length; i++){
                let type = response[i].type.toLowerCase();
                let entity = response[i].dto;
                if(type=='project'){
                  var dest = '';
                  for(var j=0; j<entity.destinations.length; j++){
                    if(dest!='') dest += ', ';
                    dest += $filter('translate')('enums.language.'+entity.destinations[j]);
                  }
                  entity.languages = $filter('translate')('enums.language.'+entity.source) + ' > ' + dest;
                  response[i].dto = entity;
                }
                if(!$scope.searchResults[type]) $scope.searchResults[type] = [];
                $scope.searchResults[type].push(response[i]);
              }
              
              $scope.searchCounter--
              if($scope.searchCounter==0){
                changeStatus('ended')
              }
              
              
            }).catch(function(err){
              $scope.searchCounter--
              if($scope.searchCounter==0){
                changeStatus('ended')
              }
            });
          }
        }
        s($scope.searchQuery)
      //}, 10)
      
    }


     
 }
 ]);